import styled from 'styled-components'

export const TableFieldWrapper = styled.div`
  display: flex;
  gap: 4px;
  position: sticky;
  top: 24px;
  height: 100%;
  margin: 4px;

  > div:first-child {
    width: 100%;
  }
`
